import { useSessionStore } from '@/stores/SessionStore.ts';
import { useSettingsStore } from '@/stores/SettingsStore.ts';
import { VariableConfigService } from '@/services/config/VariableConfigService.ts';
import { createTextToast } from '@/utils/ToastUtils.ts';
import { VariableService } from '@/services/VariableService.ts';

export const dynamicVariableToggleAction = async () => {
    const settingsStore = useSettingsStore();

    if (!settingsStore.dynamicVariableInputId || !settingsStore.dynamicVariableOutputId) {
        createTextToast(
            'No dynamic variables configured',
            'Visit the settings menu (Settings -> All settings -> Dynamic variables) to configure dynamic variables.',
            'destructive',
            true,
        );

        return;
    }

    const variableConfigs = VariableConfigService.getVariableConfigs({}, undefined, [
        'CUSTOM',
        'DEFAULT',
    ]);

    const dynamicInputVariableConfig = variableConfigs[settingsStore.dynamicVariableInputId];
    const dynamicOutputVariableConfig = variableConfigs[settingsStore.dynamicVariableOutputId];
    if (
        !dynamicInputVariableConfig ||
        !dynamicInputVariableConfig.value ||
        !dynamicOutputVariableConfig
    ) {
        createTextToast(
            'No dynamic variables configured',
            'Visit the settings menu (Settings -> All settings -> Dynamic variables) to configure dynamic variables.',
            'destructive',
            true,
        );

        return;
    }

    const sessionStore = useSessionStore();

    const inputValue = VariableService.getDefaultVariableValue(dynamicInputVariableConfig.id);
    if (!inputValue || !inputValue.length) {
        createTextToast(
            'Dynamic variables input value is empty',
            'Visit the settings menu (Settings -> All settings -> Dynamic variables) to update this dynamic variable.',
            'destructive',
            true,
        );
        return;
    }

    const nextValue = inputValue[sessionStore.dynamicVariableIndex % inputValue.length];

    VariableService.updateDefaultVariableValue(dynamicOutputVariableConfig.id, nextValue);

    createTextToast(
        `Dynamic variable updated`,
        `${dynamicOutputVariableConfig.key} = ${nextValue}`,
        'success',
        true,
    );

    sessionStore.dynamicVariableIndex = sessionStore.dynamicVariableIndex + 1;
};
